import { render, staticRenderFns } from "./Quit.vue?vue&type=template&id=2c783243&scoped=true&"
import script from "./Quit.vue?vue&type=script&lang=js&"
export * from "./Quit.vue?vue&type=script&lang=js&"
import style0 from "./Quit.vue?vue&type=style&index=0&id=2c783243&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c783243",
  null
  
)

export default component.exports